import React from 'react';
import { Flex } from 'antd';
import { UserOutlined, QrcodeOutlined } from '@ant-design/icons';

const AbhaCard = () => {
  return (
    <div
      className="abha-card-wrapper"
      style={{
        background: 'rgba(255,255,255,0.97)',
        borderRadius: 20,
        padding: '28px 28px 24px',
        width: 340,
        boxShadow: '0 25px 60px rgba(0,0,0,0.35), 0 8px 20px rgba(107,53,212,0.2)',
        backdropFilter: 'blur(10px)',
        border: '1px solid rgba(255,255,255,0.3)',
      }}
    >
      {/* Header row */}
      <Flex justify="space-between" align="flex-start" className="mb-4">
        <div>
          <p className="text-xs font-semibold tracking-widest mb-1" style={{ color: '#7c5cbf', letterSpacing: '0.08em' }}>
            AYUSHMAN BHARAT
          </p>
          <p className="text-xl font-bold" style={{ color: '#1a1a2e' }}>
            ABHA Card
          </p>
        </div>
        <div
          className="px-3 py-1 rounded-lg text-xs font-semibold"
          style={{ background: '#f0eaff', color: '#6B35D4', lineHeight: 1.6 }}
        >
          Govt. of India
          <br />
          <span style={{ color: '#9575cd', fontWeight: 500 }}>ABDM · NHA</span>
        </div>
      </Flex>

      {/* Avatar */}
      <div
        className="flex items-center justify-center mb-3"
        style={{
          width: 64,
          height: 64,
          borderRadius: '50%',
          background: 'linear-gradient(135deg, #d0bbff 0%, #b39ddb 100%)',
        }}
      >
        <UserOutlined style={{ fontSize: 30, color: '#6B35D4' }} />
      </div>

      {/* Name */}
      <p className="text-xl font-bold mb-4" style={{ color: '#1a1a2e' }}>
        Rahul Kumar
      </p>

      {/* ABHA Number */}
      <div className="mb-3">
        <p
          className="text-xs font-semibold tracking-widest mb-1"
          style={{ color: '#9e9e9e', letterSpacing: '0.1em' }}
        >
          ABHA NUMBER
        </p>
        <p className="text-base font-bold" style={{ color: '#1a1a2e', letterSpacing: '0.04em' }}>
          1234-5678-9012-3456
        </p>
      </div>

      {/* Gender & DOB */}
      <div className="mb-4">
        <p
          className="text-xs font-semibold tracking-widest mb-1"
          style={{ color: '#9e9e9e', letterSpacing: '0.1em' }}
        >
          GENDER &amp; DATE OF BIRTH
        </p>
        <Flex align="center" gap={12}>
          <span className="text-sm font-semibold" style={{ color: '#1a1a2e' }}>
            Male
          </span>
          <span style={{ color: '#9e9e9e' }}>|</span>
          <span className="text-sm font-semibold" style={{ color: '#1a1a2e' }}>
            15 Aug 1990
          </span>
        </Flex>
      </div>

      {/* ABHA Address + QR */}
      <Flex justify="space-between" align="flex-end">
        <div>
          <p
            className="text-xs font-semibold tracking-widest mb-1"
            style={{ color: '#9e9e9e', letterSpacing: '0.1em' }}
          >
            ABHA ADDRESS
          </p>
          <p className="text-sm font-semibold" style={{ color: '#6B35D4' }}>
            rahulkumar@abdm
          </p>
        </div>
        <div
          className="flex items-center justify-center rounded-xl"
          style={{
            width: 52,
            height: 52,
            background: '#f0eaff',
            border: '1px solid #e0d6ff',
          }}
        >
          <QrcodeOutlined style={{ fontSize: 28, color: '#6B35D4' }} />
        </div>
      </Flex>
    </div>
  );
};

export default AbhaCard;
